"use client";
import { ErrorBoundary } from "@sentry/nextjs";
import { DreamMuiHandledErrorRefresh } from "@portal/app/_components/ui-elements/Mui/DreamMuiHandledError";
import { ErrorPageNavBar } from "@portal/app/_components/ui-elements/CustomerNavBar/ErrorPageNavBar";
import { Layout } from "@portal/app/_components/ui-elements/Layout";
import { PageProvider } from "./context/PageContext";

export const DreamErrorBoundary = ({ children }: React.PropsWithChildren) => (
  <PageProvider
    tokenInfo={undefined}
    deviceInfo={null}
    experiments={undefined}
    cfGeolocation={{
      cfCountry: undefined,
      cfCity: undefined,
      cfState: undefined,
      cfZip: undefined,
    }}
  >
    <ErrorBoundary
      fallback={
        <Layout nav={<ErrorPageNavBar />} showDisclaimer={false}>
          <DreamMuiHandledErrorRefresh
            title="We're sorry, something went wrong"
            content="If you followed a link, it might have been to a page that moved or doesn't exist
          anymore. Sorry about that!"
          />
        </Layout>
      }
      showDialog
    >
      {children}
    </ErrorBoundary>
  </PageProvider>
);
